import i18n from "@/locales/i18n";

export function loadBodyMap() {
  jQuery("#image-map-pro-container").imageMapPro({
    id: 3019,
    editor: {
      tool: "select",
      shapeCounter: { spots: 1, ovals: 2, polys: 3 }
    },
    general: {
      name: "Body",
      width: 480,
      height: 1127,
      naturalWidth: 480,
      naturalHeight: 1127
    },
    image: {
      url: require("@/assets/images/map_body_hotspots_small2.png")
    },
    fullscreen: {
      fullscreen_button_position: 2,
      fullscreen_button_type: "icon"
    },
    shapes: { glow_opacity: 0.5122699386503068 },
    tooltips: {
      sticky_tooltips: 1,
      tooltip_animation: "fade",
      fullscreen_tooltips: "none"
    },
    layers: {
      layers_list: [
        {
          id: 0,
          title: "Main Floor",
          image_url: require("@/assets/images/map_body_hotspots2.png"),
          image_width: 1000,
          image_height: 1922
        }
      ]
    },
    spots: [
      {
        id: "oval-9339",
        title: i18n.t("bodymap_headaches"),
        type: "oval",
        x: 37.902,
        y: 1.631,
        width: 22.597,
        height: 12.052,
        x_image_background: 37.902,
        y_image_background: 1.631,
        width_image_background: 22.597,
        height_image_background: 12.052,
        default_style: { opacity: 0 },
        mouseover_style: {
          opacity: 0.43,
          background_color: "#d7df23",
          background_opacity: 0.38
        },
        tooltip_style: {
          background_color: "#d6e619",
          background_opacity: 0.39947916666666666,
          position: "left",
          width: 251,
          auto_width: 0,
          offset_x: -9.101020029537858,
          offset_y: 0.9296825595984943
        },
        tooltip_content: {
          squares_settings: {
            containers: [
              {
                id: "sq-container-358391",
                settings: {
                  elements: [
                    {
                      settings: {
                        name: "Heading",
                        iconClass: "fa fa-header"
                      },
                      options: {
                        heading: {
                          text: i18n.t("bodymap_headaches")
                        },
                        font: { font_size: "16" }
                      }
                    }
                  ]
                }
              }
            ]
          }
        }
      },
      {
        id: "oval-7726",
        title: "Oval 1",
        type: "oval",
        x: 91.336,
        y: 7.607,
        width: 0,
        height: 0,
        x_image_background: 91.336,
        y_image_background: 7.607,
        width_image_background: 0,
        height_image_background: 0,
        tooltip_content: {
          squares_settings: {
            containers: [
              {
                id: "sq-container-403761",
                settings: {
                  elements: [
                    {
                      settings: {
                        name: "Heading",
                        iconClass: "fa fa-header"
                      },
                      options: { heading: { text: "Oval 1" } }
                    }
                  ]
                }
              }
            ]
          }
        }
      },
      {
        id: "poly-4327",
        title: "Poly 0",
        type: "poly",
        x: 35.253,
        y: 19.196,
        width: 32.521,
        height: 12.171,
        x_image_background: 34.664,
        y_image_background: 19.196,
        default_style: { background_opacity: 0 },
        mouseover_style: {
          background_color: "#d7df23",
          background_opacity: 0.1,
          stroke_opacity: 0.11
        },
        tooltip_style: {
          background_color: "#d6e619",
          background_opacity: 0.49166666666666664,
          position: "left",
          width: 288,
          auto_width: 0,
          offset_x: -21.60518651322669,
          offset_y: -2.136052697616062
        },
        tooltip_content: {
          squares_settings: {
            containers: [
              {
                id: "sq-container-826851",
                settings: {
                  elements: [
                    {
                      settings: {
                        name: "Heading",
                        iconClass: "fa fa-header"
                      },
                      options: {
                        heading: {
                          text: i18n.t("bodymap_asthma")
                        },
                        font: { font_size: "16" }
                      }
                    }
                  ]
                }
              }
            ]
          }
        },
        points: [
          { x: 13.767772153868355, y: 14.433775954765782 },
          { x: 30.339295656142983, y: 7.107049388837009 },
          { x: 46.413955317474134, y: 0 },
          { x: 70.98604193304608, y: 7.21640860166865 },
          { x: 89.94662222780336, y: 25.773634795079193 },
          { x: 100, y: 51.54995854527527 },
          { x: 95.78797281212204, y: 74.22965170561915 },
          { x: 79.55243100834402, y: 93.81405875366924 },
          { x: 56.54869278124261, y: 100 },
          { x: 29.52089126111124, y: 97.934733083858 },
          { x: 13.359914254371146, y: 82.4701040476243 },
          { x: 0.8273619578183757, y: 62.88405374922501 },
          { x: 0, y: 37.116339925754936 }
        ]
      },
      {
        id: "poly-243",
        title: "Bauch",
        type: "poly",
        x: 35.706,
        y: 40.164,
        width: 27.89,
        height: 13.502,
        x_image_background: 34.822,
        y_image_background: 38.997,
        default_style: { background_opacity: 0 },
        mouseover_style: {
          background_color: "#d7df23",
          background_opacity: 0.12,
          stroke_opacity: 0.14
        },
        tooltip_style: {
          background_color: "#d6e619",
          background_opacity: 0.453125,
          position: "left",
          auto_width: 0,
          offset_x: -14.88164750627353,
          offset_y: -0.2839096612296075
        },
        tooltip_content: {
          squares_settings: {
            containers: [
              {
                id: "sq-container-441781",
                settings: {
                  elements: [
                    {
                      settings: {
                        name: "Heading",
                        iconClass: "fa fa-header"
                      },
                      options: {
                        heading: { text: i18n.t("bodymap_nausea") },
                        font: { font_size: "16" }
                      }
                    }
                  ]
                }
              }
            ]
          }
        },
        points: [
          { x: 39.051417872952015, y: 0 },
          { x: 69.4619463682512, y: 2.5053080744825853 },
          { x: 91.23360570662942, y: 16.17255801518713 },
          { x: 100, y: 47.48666059192313 },
          { x: 93.28384065218626, y: 74.31722974630442 },
          { x: 78.54367722820858, y: 95.95849739791873 },
          { x: 51.93274329603145, y: 100 },
          { x: 21.644807608839212, y: 93.98853676344045 },
          { x: 1.3069528223886775, y: 73.11474473216884 },
          { x: 0, y: 39.830873887778104 },
          { x: 11.193598913022953, y: 14.148103634082515 }
        ]
      }
    ]
  });
}
